import React from "react"

import { ALL_BUT_DIGITS_REGEX } from "@axtesys/react-tools"

import { TextInput, TextInputProps } from "./TextInput"

export function IntegerTextInput({ value, ...props }: TextInputProps) {
  return (
    <TextInput
      {...props}
      keyboardType="number-pad"
      value={value?.replace(ALL_BUT_DIGITS_REGEX, "")}
    />
  )
}
